import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";

import Config from "../../../../config";
import FormCheckbox from "../../../../components/molecules/checkbox";
import PageConfig, { PageContext } from "../../config";
import PaymentMethodSelector from "./payment-method-selector";
import CardPaymentMethodSelector from "./card-payment-method-selector";
import PageDomain from "../../domain";
import PayhereMerchantForm from "./payhere-merchant-form";

const { CHECKOUT_OPTION_ENUM, PAYMENT_METHOD_ERROR } = PageConfig;

const PaymentView = () => {
  const { t } = useTranslation();
  const {
    paymentLinkData,
    currency,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    secondaryPaymentMethod,
    formErrors,
    setFormErrors,
    submitCount,
    setSubmitCount,
    agreedToTerms,
    setAgreedToTerms,
    promoCode,
  } = useContext(PageContext);

  const [showPaymentMethodSelector, setShowPaymentMethodSelector] =
    React.useState(true);
  const [payhereParams, setPayhereParams] = React.useState({});
  const [formSubmitting, setFormSubmitting] = React.useState(false);

  const getFieldError = ({ fieldName, error, t }) => {
    if (error === PAYMENT_METHOD_ERROR.REQUIRED) {
      return t("errors.formRequiredField", { fieldName: t(fieldName) });
    }
    return t("errors.unknownErrorOccurred");
  };

  const onClickContinue = async () => {
    PageDomain.onClickPaymentContinueBtn({
      currency,
      paymentLinkData,
      selectedPaymentMethod,
      secondaryPaymentMethod,
      submitCount,
      agreedToTerms,
      promoCode,
      setFormErrors,
      setSubmitCount,
      setPayhereParams,
      setFormSubmitting,
    });
  };

  React.useEffect(() => {
    PageDomain.loadStripeScript();
  }, []);

  React.useEffect(() => {
    const activatedMethods = Object.values(CHECKOUT_OPTION_ENUM).filter(
      (element) => element.activated
    );
    if (activatedMethods.length === 1) {
      setSelectedPaymentMethod(activatedMethods[0]);
      setShowPaymentMethodSelector(false);
    }
  }, [setSelectedPaymentMethod]);

  React.useEffect(() => {
    if (submitCount > 0) {
      const formErrors = PageDomain.validatePaymentForm({
        selectedPaymentMethod,
        secondaryPaymentMethod,
        agreedToTerms,
      });
      console.log(">>>>> formErrors >>> ", formErrors);
      setFormErrors(formErrors);
    }
  }, [
    agreedToTerms,
    secondaryPaymentMethod,
    selectedPaymentMethod,
    setFormErrors,
    submitCount,
  ]);

  console.log(">>>>> useEffect formErrors ", formErrors);

  return (
    <Grid container direction="column" className="payment-view">
      <Typography className="typography-body-1 capitalized-text text-semi-bold">
        {t("payment.paymentMethods")}
      </Typography>
      <Grid item container direction="column" className="form-container">
        <>
          {showPaymentMethodSelector && (
            <Grid container className="form-element">
              <Typography className="typography-caption-1 capitalized-text text-semi-bold">
                {t("payment.paymentMethod")}
                {/* <span className="required">*</span> */}
              </Typography>
              <PaymentMethodSelector />
            </Grid>
          )}
          {selectedPaymentMethod.id ===
            CHECKOUT_OPTION_ENUM.online_payment.id && (
            <Grid container className="form-element">
              <Grid item className="margin-bottom-8">
                <Typography className="typography-caption-1 capitalized-text text-semi-bold">
                  {t("payment.creditDebitPaymentMethod")}
                  {/* <span className="required">*</span> */}
                </Typography>
                <Typography className="typography-caption-1 font-weight-300">
                  {t("settingPage.redirectToGatewayNotice")}
                </Typography>
              </Grid>
              <CardPaymentMethodSelector />
              {!isEmpty(formErrors.secondaryPaymentMethod) && (
                <Typography className="typography-body-2 form-error-text-accent-1">
                  {getFieldError({
                    fieldName: "payment.creditDebitPaymentMethod",
                    error: formErrors.secondaryPaymentMethod,
                    t,
                  })}
                </Typography>
              )}
            </Grid>
          )}
        </>
        <Grid container direction="column" className="row-gap-8">
          <FormCheckbox
            id="payment-terms-checked"
            label={t("payment.agreeToTerms", {
              domainName: Config.DOMAIN_DISPLAY_NAME,
            })}
            handleChange={(e) => {
              setAgreedToTerms(e.target.checked);
            }}
            containerProps={{
              ...(formErrors.agreedToTerms && {
                border: "1px solid var(--error-red-accent-1)",
              }),
            }}
          />
          <Button
            className="primary-button"
            onClick={onClickContinue}
            disabled={formSubmitting || !isEmpty(formErrors)}
            startIcon={
              formSubmitting && (
                <CircularProgress
                  size={18}
                  style={{ color: "var(--primary-color)" }}
                />
              )
            }
          >
            {t("common.continue")}
          </Button>
        </Grid>
      </Grid>
      <PayhereMerchantForm payhereParams={payhereParams} />
    </Grid>
  );
};

export default PaymentView;
